import { useAuth } from "react-oidc-context";
import { Outlet } from "react-router-dom";
import { AnonUnauthorizedError } from "./ErrorElement/AnonUnauthorizedError";

/**
 * ProtectedLayout renders a react-router-dom \<Outlet /> only if user is authenticated, protecting the route. 
 * ErrorElement will present the same error if user tries to load a route and related loaders/actions return a 401.
 * ProtectedLayout with doFetch + returnIfNotSignedIn = true, prevents the front-end making an unnecessary web 
 * request if the front-end already knows what to protect.
 * 
 * <Route errorElement={<ErrorElement />}>
 *    <Route element={<ProtectedLayout />}>
 *        <Route path="/my-profile" element={<MyProfileRoute />} loader={myProfileRouteLoader} />
 */
export const ProtectedLayout = () => {
  const auth = useAuth();
  if (!auth.isAuthenticated) {
    return <AnonUnauthorizedError />;
  }
  return <><Outlet /></>;
};